import { DocumentTemplateMinDto } from 'types/document';
import { CustomizationDto } from 'types/invoices';

interface TemplatePick {
    invoiceTemplateId: number | undefined;
    invoiceSpecTemplateId: number | undefined;
}

/**
 * The customization a form keeps once a template is picked: a customization is made against its templates'
 * options, so other templates start from their own defaults, and the saved templates get the saved one back.
 */
export const customizationAfterTemplatePick = (
    picked: TemplatePick,
    saved: TemplatePick & { invoiceCustomization: CustomizationDto | null | undefined }
): CustomizationDto | null =>
    picked.invoiceTemplateId === saved.invoiceTemplateId && picked.invoiceSpecTemplateId === saved.invoiceSpecTemplateId
        ? (saved.invoiceCustomization ?? null)
        : null;

export const supportedCustomization = (
    invoiceTemplate: DocumentTemplateMinDto | undefined,
    invoiceSpecTemplate: DocumentTemplateMinDto | undefined,
    currentCustomization: CustomizationDto | null | undefined
): Partial<CustomizationDto> => {
    const baseCustomization = {
        ...invoiceTemplate?.supportedCustomizationOptionsDefaultValues,
        ...Object.fromEntries(
            Object.entries(invoiceSpecTemplate?.supportedCustomizationOptionsDefaultValues || {}).filter(
                ([, value]) => value !== null && value !== undefined
            )
        ),
    };

    return {
        ...baseCustomization,
        ...(currentCustomization
            ? Object.fromEntries(
                  (Object.keys(baseCustomization) as (keyof CustomizationDto)[])
                      .filter((key) => key in currentCustomization && currentCustomization[key] !== null)
                      .map((key) => [key, currentCustomization[key]])
              )
            : {}),
    };
};
